module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('form', [_c('table', [_c('tr', [_c('td', [_vm._v("\n              Content:\n            ")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testimonial.content),
      expression: "testimonial.content"
    }],
    attrs: {
      "name": "content",
      "cols": "50",
      "rows": "20",
      "maxlength": "5000"
    },
    domProps: {
      "value": _vm._s(_vm.testimonial.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testimonial.content = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Author:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testimonial.author),
      expression: "testimonial.author"
    }],
    attrs: {
      "type": "text",
      "name": "author",
      "size": "33",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.testimonial.author)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testimonial.author = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Type: (free member, customer, etc)\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testimonial.type),
      expression: "testimonial.type"
    }],
    attrs: {
      "type": "text",
      "name": "type",
      "size": "20",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm._s(_vm.testimonial.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testimonial.type = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59438b56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/Testimonial.vue
// module id = 503
// module chunks = 1